import React, {useState, useRef, useEffect} from "react";
import '../pages/ContactUs';
import axios from 'axios';

function ContactForm(props) {

  const prefillData = props.prefillData;

  const [formData, setFormData] = useState({user_name:'',email:'',subject:((prefillData.subject)?prefillData.subject:"blank"),contact_method:"blank"})

  useEffect(() => {
    if (prefillData) {
      setFormData(prefillData)
    }
    console.log(prefillData)
  }, [prefillData]);

  useEffect(() => {
    console.log(formData)
  }, [formData]);


  const handleChange = (e) => {
    
    const {name, value} = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    
    }))
    console.log(formData)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(process.env.REACT_APP_BACKEND_URL)
    console.log(formData)
    axios.post(process.env.REACT_APP_BACKEND_URL + "/sendMail", formData, {headers: {
      'Content-Type': 'application/json'
    }})
    .then((response) => {
      if (response.status == 200) {
        alert("Message sent! We will get back to you as soon as possible.")
      } else {
        alert("There was an error sending your message. Please try again.")
      }
    })
    .catch(error => {
      alert("We were unable to process your request. Please try again.")
      console.log(error)
    })
  }

  return (
    <form 
      onSubmit={handleSubmit} 
      style={{
        width: "100%",
        border: "black 2px solid",
        borderRadius:"20px",
        boxSizing:"border-box",
        padding: "5px",
        background: "#ff826c"
      }} 
    >
      <h1>Contact Form</h1>
      <label><span style={{color: "red"}}>*</span> indicates a required field.</label>
      <div> 
        <label><span style={{color: "red"}}>*</span>Full name</label>
        <input onChange={handleChange} style={{margin: "10px", boxSizing:"border-box"}} required type="text" name="user_name" />
      </div>
      <div>
        <label>Email</label>
        <input onChange={handleChange} style={{margin: "10px", boxSizing:"border-box"}} type="email" name="user_email" />
      </div>
      <div>
        <label>Phone number</label>
        <input onChange={handleChange} style={{margin: "10px", boxSizing:"border-box"}} type="tel" name="user_telephone_number" pattern="[0-9]{3}-?[0-9]{3}-?[0-9]{4}" placeholder="XXX-XXX-XXXX"/>
      </div>
      <div>
        <label><span style={{color: "red"}}>*</span>Preferred contact method</label>
        <select onChange={handleChange} style={{margin: "10px", boxSizing:"border-box"}} name="contact_method" required>
          {formData.contact_method=="blank" ? 
            <option value="blank">Choose an option</option> : 
            <option value="blank" disabled hidden>Choose an option</option>
          }
          <option value="call">Call</option>
          <option value="text">Text</option>
          <option value="email">Email</option>
        </select>
      </div>
      <div>
        <label><span style={{color: "red"}}>*</span>Subject</label>
        <select onChange={handleChange} defaultValue={formData.subject} style={{margin: "10px", boxSizing:"border-box"}} name="subject" required>
          {formData.subject=="blank" ? 
            <option value="blank">Choose an option</option> : 
            <option value="blank" disabled hidden>Choose an option</option>
          }
          <option value="Get An Estimate">Get an estimate</option>
          <option value="Billing Concern">Billing concern</option>
          <option value="Ask a Question">Ask a question</option>
          <option value="File a Complaint">File a complaint</option>
          <option value="Employment Inquiry">Employment Inquiry</option>
          <option value="Other">Other (specify in message)</option>
        </select>
      </div>
      <div>
        <label><span style={{color: "red"}}>*</span>Message</label>
      </div>
      <div>
        <textarea onChange={handleChange} style={{marginTop: "10px", boxSizing: "border-box", width: "95%", height: "20vh"}} required name="message" />
      </div>
      <input type="submit" value="Send" />
      
  </form>
  )
}

export default ContactForm